import React, { Component } from "react";
import appealImg from "../../static/images/appealImg.png";
import styles from "./index.less";

interface Props {
  punishDetails: any[];
}
interface State { }

class PunishCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }
  punishTimeFormat = (time: string) => {
    return time.replace(/-/g, '/');
  };
  render() {
    const { punishDetails } = this.props;
    return (
      <div className={styles.PunishCard}>
        {punishDetails
          ? punishDetails.map((item: any, index: number) => {
            const {
              punishId,
              punishNames,
              punishStatus,
              appealStatus,
              recovery,
              endTime,
              punishTime,
              punishReason
            } = item;
            const isWeiliaoPunish = punishNames[0] === '微聊禁言';
            const reasonList = punishReason ? punishReason.split('|') : [];
            return (
              <div className={styles.singleCard} key={index}>
                <img src={appealImg} />
                <div className={styles.singleInfo}>
                  <div className={styles.info}>
                    {punishNames[0] !== '微聊禁言' && <span className={styles.punishNumber}>
                      处罚编号：{punishId}
                    </span>}
                    <span className={punishNames[0] !== '微聊禁言' ? styles.punishStauts : styles.status}>
                      {appealStatus === 5 ? (
                        <i style={{ color: "#9B9B9B" }}>处罚维持原判</i>
                      ) : recovery ||
                        appealStatus === 4 ||
                        punishStatus === 3 ||
                        punishStatus === 2 ? (
                        <i style={{ color: "#35AD45" }}>处罚已撤销</i>
                      ) : (
                        <i style={{ color: "#FF6235" }}>已处罚</i>
                      )}
                    </span>
                  </div>

                  <span className={styles.punishType}>
                    处罚方式：
                    {punishNames.map((item: string, index: number) => {
                      return (
                        <i key={index}>
                          {item}
                          {index !== punishNames.length - 1 ? "," : ""}
                        </i>
                      );
                    })}
                  </span>
                  <div className={styles.punishReason}>
                    <div className={styles.reason}>处罚原因：</div>
                    <div className={styles.reasonContent}>
                      {reasonList.length > 0 ? reasonList.map((reason: string, index: number) =>
                        <div
                          className={styles.reason}
                          style={{ WebkitBoxOrient: "vertical" }}>
                          {reasonList.length > 1 ? `${index + 1}. ${reason}` : `${reason}`}
                        </div>
                      ): null}
                    </div>
                  </div>
                  {isWeiliaoPunish && endTime && <span className={styles.punishType}>
                    <span>截止时间：</span>
                    <span style={{ fontWeight: 400 }}>{this.punishTimeFormat(endTime)}</span>
                  </span>}
                  <span className={styles.punishType}>
                    <span>处罚时间：</span>
                    <span style={{ fontWeight: 400 }}>{this.punishTimeFormat(punishTime)}</span>
                  </span>
                </div>
              </div>
            );
          })
          : null}
      </div>
    );
  }
}

export default PunishCard;
